import { render, staticRenderFns } from "./NewsTemplate.vue?vue&type=template&id=3f0dfc83&scoped=true&"
import script from "./NewsTemplate.vue?vue&type=script&lang=js&"
export * from "./NewsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./NewsTemplate.vue?vue&type=style&index=0&id=3f0dfc83&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0dfc83",
  null
  
)

export default component.exports